import type { Question, Response } from "../../lib/types";
import { MCQAnswer } from "./MCQAnswer";
import { NPSAnswer } from "./NPSAnswer";
import { PolarAnswer } from "./PolarAnswer";
import { LikertAnswer } from "./LikertAnswer";

type Props = {
  question: Question;
  streamId?: string | null;
  onSubmitted: (row: Response) => void;
  onError: (message: string) => void;
  /** Render prop for the open-text submit UI — keeps existing UX untouched. */
  renderOpenText: () => JSX.Element;
};

export function AnswerDispatcher(props: Props) {
  const { question, renderOpenText, ...rest } = props;
  switch (question.question_type) {
    case "nps":
      return <NPSAnswer question={question} {...rest} />;
    case "multiple_choice":
      return <MCQAnswer question={question} {...rest} />;
    case "polar":
      return <PolarAnswer question={question} {...rest} />;
    case "likert":
      return <LikertAnswer question={question} {...rest} />;
    case "open_text":
    default:
      return renderOpenText();
  }
}
